class CartDrawerUpsellCarousel extends HTMLElement {
  constructor() {
    super();

    this.slides = Array.from(this.querySelectorAll('.cart-drawer__upsell-slide'));
    this.prevButton = this.querySelector('.cart-drawer__upsell-prev');
    this.nextButton = this.querySelector('.cart-drawer__upsell-next');
    this.index = 0;

    this.prevButton?.addEventListener('click', () => this.go(-1));
    this.nextButton?.addEventListener('click', () => this.go(1));

    this.slides.forEach((slide) => this.initSlide(slide));
    this.updateNav();
  }

  go(delta) {
    if (this.slides.length < 2) return;
    this.slides[this.index].hidden = true;
    this.index = (this.index + delta + this.slides.length) % this.slides.length;
    this.slides[this.index].hidden = false;
    this.updateNav();
  }

  updateNav() {
    const hasMultiple = this.slides.length > 1;
    this.prevButton?.toggleAttribute('hidden', !hasMultiple);
    this.nextButton?.toggleAttribute('hidden', !hasMultiple);
  }

  initSlide(slide) {
    const dataEl = slide.querySelector('[data-upsell-variants]');
    if (!dataEl) return;

    let variants = [];
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }

    const selects = Array.from(slide.querySelectorAll('.cart-drawer__upsell-select'));
    const idInput = slide.querySelector('[data-upsell-variant-id]');
    const priceEl = slide.querySelector('[data-upsell-price]');
    const compareEl = slide.querySelector('[data-upsell-compare-price]');
    const badgeEl = slide.querySelector('.cart-drawer__upsell-badge');
    const addButton = slide.querySelector('.cart-drawer__upsell-add');
    const addButtonLabel = addButton?.querySelector('span');

    if (selects.length === 0 || !idInput) return;

    const updateVariant = () => {
      const selected = selects.map((select) => select.value);
      const match = variants.find((variant) =>
        selected.every((value, index) => variant.options[index] === value)
      );

      if (!match) {
        if (addButton) {
          addButton.disabled = true;
          addButton.setAttribute('aria-disabled', 'true');
        }
        return;
      }

      idInput.value = match.id;

      if (priceEl) priceEl.textContent = match.price_formatted;

      if (compareEl) {
        const onSale = match.compare_at_price && match.compare_at_price > match.price;
        compareEl.hidden = !onSale;
        if (onSale) compareEl.textContent = match.compare_at_price_formatted;

        if (badgeEl) {
          if (onSale) {
            const percent = Math.round((1 - match.price / match.compare_at_price) * 100);
            badgeEl.hidden = false;
            badgeEl.textContent = badgeEl.dataset.template
              ? badgeEl.dataset.template.replace('__PERCENT__', percent)
              : `-${percent}%`;
          } else {
            badgeEl.hidden = true;
          }
        }
      }

      if (addButton) {
        addButton.disabled = !match.available;
        addButton.toggleAttribute('aria-disabled', !match.available);
        if (addButtonLabel) {
          addButtonLabel.textContent = match.available
            ? window.variantStrings?.addToCart || addButtonLabel.textContent
            : window.variantStrings?.soldOut || addButtonLabel.textContent;
        }
      }
    };

    selects.forEach((select) => select.addEventListener('change', updateVariant));
  }
}

customElements.define('cart-drawer-upsell-carousel', CartDrawerUpsellCarousel);
